/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Nopassworddesc2Inputs */

const zh_password_nopassworddesc2 = /** @type {(inputs: Password_Nopassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的账户尚未配置密码。如果您希望启用密码登录，我们将发送密码设置链接到您的邮箱。`)
};

const en_password_nopassworddesc2 = /** @type {(inputs: Password_Nopassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account does not have a password yet. To enable password login, we will send a setup link to your email.`)
};

const es_password_nopassworddesc2 = /** @type {(inputs: Password_Nopassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta aún no tiene contraseña. Para habilitar el inicio de sesión con contraseña, enviaremos un enlace de configuración a tu correo.`)
};

/**
* | output |
* | --- |
* | "Your account does not have a password yet. To enable password login, we will send a setup link to your email." |
*
* @param {Password_Nopassworddesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_nopassworddesc2 = /** @type {((inputs?: Password_Nopassworddesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Nopassworddesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_nopassworddesc2(inputs)
	if (locale === "en") return en_password_nopassworddesc2(inputs)
	return es_password_nopassworddesc2(inputs)
});
export { password_nopassworddesc2 as "password_noPasswordDesc" }